var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M12 22a10 10 0 0 0 0-20m0 20a10 10 0 0 1 0-20m0 20c2.3 0 3.7-3 4.3-6.6M12 22c-2.3 0-3.7-3-4.3-6.6M12 2c2.3 0 3.7 3 4.3 6.7M12 2C9.7 2 8.3 5 7.7 8.7m-4.5 0h4.5m0 0h8.6m-8.6 0a25 25 0 0 0 0 6.7m8.6-6.7h4.4m-4.4 0a25 25 0 0 1 0 6.7m-13 0h4.4m0 0h8.6m0 0h4.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.156ab7ce32e06d4409b12543d00daace.svg";
export { ForwardRef as ReactComponent };